import { useParams, Link } from "react-router-dom";
import SEOHead from "@/components/base/SEOHead";
import Breadcrumb from "@/components/base/Breadcrumb";
import ArticleCard from "@/components/base/ArticleCard";
import { siteInfo } from "@/mocks/siteInfo";
import { categories } from "@/mocks/categories";
import { getArticlesByCategory } from "@/mocks/articles";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const articles = slug ? getArticlesByCategory(slug) : [];

  if (!category) {
    return (
      <div className="pt-16 min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-foreground-950 mb-2">分类未找到</h1>
          <Link to="/" className="text-sm text-primary-500 hover:text-primary-600">
            返回首页
          </Link>
        </div>
      </div>
    );
  }

  const pageTitle = `${category.name} - ${siteInfo.name}`;
  const pageDesc = `${category.description} 国模白露${category.name}作品集，为摄影爱好者提供专业写真欣赏与风格参考。`;
  const pageUrl = `${siteInfo.url}/category/${slug}`;

  return (
    <>
      <SEOHead
        title={pageTitle}
        description={pageDesc}
        keywords={`${category.name},国模白露,白露写真,${siteInfo.keywords}`}
        canonicalUrl={pageUrl}
        ogType="website"
      />

      <div className="pt-20 pb-12 md:pb-16 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: "首页", to: "/" },
              { label: category.name },
            ]}
          />

          <div className="mt-6 mb-10">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950">
              {category.name}
            </h1>
            <p className="text-sm text-foreground-500 mt-2 max-w-2xl">
              {category.description}
            </p>
          </div>

          {articles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map((article) => (
                <ArticleCard key={article.slug} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100 mb-4">
                <i className="ri-image-line text-2xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500">该分类暂无内容，敬请期待</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}